<template>
<div class="dashboard-widget-tabs p-0">
	<div class="dashboard-widget-tabs-content mb-0" style="padding: 15px !important;">
		<h2>
			<i class="uil uil-bell"></i>
			هشدارها
		</h2>
		<div class="dashboard-widget-h-btns">
			<a v-if="sidebarShow == true" href="" @click.prevent="hideSidebar()" class="m-left m-top tgju-btn tgju-btn-primary" v-tooltip="'هشدارها'"><i class="uil uil-list-ui-alt"></i> <span class="hide-m-min"> هشدارها </span></a>				
			<a v-if="!widgetLoad" href="" @click.prevent="open_alert_add_modal()" class="m-left m-top tgju-btn tgju-btn-primary" v-tooltip="'افزودن هشدار'"><i class="uil uil-plus-circle"></i> <span class="hide-m-min">افزودن هشدار </span></a>				
		</div>
	</div>

	<div class="sidebar-box">
		<slot v-if="widgetLoad">
			<div class="tgju-widget-content full-padding">
				<div class="text-center p-2">
					<div class="widget-loading"></div>
				</div>
			</div>		
		</slot>
		<slot v-else>
			<slot v-if="alerts.length">
				<table class="widget-table widget-table-lg" v-if="sidebarShow == false">
					<thead>
						<tr>
							<th class="w60 text-center">#</th>
							<th>عنوان</th>
							<th class="text-center hide-table-r hide-640">شاخص</th>
							<th class="text-center hide-640">آخرین ‌قیمت</th>
							<th class="hide-640 text-center">بیشترین</th>
							<th class="hide-640 text-center">کمترین</th>
							<th class="hide-table-r hide-640 text-center">نوع نوسان</th>
							<th class="hide-table-r hide-1200 text-center">کانال‌های‌ دریافت</th>
							<th class="w60 text-center">ویرایش</th>
							<th class="w60 text-center">حذف</th>
						</tr>
					</thead>
					<tbody>
						<tr class="pointer" v-for="alert in alerts" :key="alert.id" @click.prevent="showSidebar(alert.id)">
							<td class="border-l bg-gray w60 text-center">  {{ alert.id }}</td>
							<td class="border-l bg-gray">  {{ alert.title }}</td>
							<td class="border-l text-center hide-table-r hide-640">{{ $helpers.json_pars(alert.asset)['label'] }}</td>
							<!-- <td class="border-l text-center hide-table-r hide-640">{{ $helpers.json_pars(alert.asset)['symbol'] }}</td> -->
							<td class="border-l text-center hide-640">
								{{ getPrice($helpers.json_pars(alert.asset)['symbol']) }}
							</td>
							<!-- {{ $helpers.json_pars(alert.asset) }} -->
							<td class="border-l text-center hide-640">{{ alert.max }}</td>
							<td class="border-l text-center hide-640">{{ alert.min }}</td>
							<td class="border-l text-center hide-table-r">
								<span v-if="alert.type == 'exact' " >مقدار ثابت</span>
								<span v-if="alert.type == 'amount' " >مقدار نوسان</span>
								<span v-if="alert.type == 'percentage' " >درصد نوسان</span>
							</td>
							<td class="border-l text-center hide-table-r hide-1200">
								<!-- <i class="uil uil-message table-icons alert-t-btn" :class="{'active': alert.notification_messenger}"></i> -->
								<i class="uil uil-envelope table-icons alert-t-btn" v-tooltip="'ایمیل'" :class="{'active': alert.notification_email}"></i>
								<i class="uil uil-bell table-icons alert-t-btn " v-tooltip="'پوش‌نوتیفیکیشن'" :class="{'active': alert.notification_push}"></i>
							</td>
							<td class="w60 text-center border-l"><i class="uil uil-edit-alt table-icons pointer" v-tooltip="'ویرایش'" @click.stop="open_alert_add_modal(alert.id)"></i></td>
							<td class="w60 text-center"><i class="uil uil-trash table-icons red-color pointer" v-tooltip="'حذف'" @click.stop="removeAlert(alert.id)"></i></td>
						</tr>
					</tbody>
				</table> 
			</slot>
			<div v-if="!alerts.length" class="popup-dash-empty">
				<i class="uil uil-bell" aria-hidden="true"></i>
				<span>تاکنون هشداری به ثبت نرسیده است</span>
			</div>

			<div class="list-row l-head" v-if="sidebarShow == true">
				<div class="list-col l-title">
					<span>تاریخچه هشدارها</span>
				</div>
			</div>
			<div class="tgju-widget-content full-padding" v-if="sidebarShow == true">
				<slot v-if="widgetLoad">
					<div class="tgju-widget-content full-padding">
						<div class="text-center p-2">
							<div class="widget-loading"></div>
						</div>
					</div>		
				</slot>
				<slot v-else>
					<table class="widget-table widget-table-lg">
						<thead>
							<tr>
								<th class="w60 text-center">#</th>
								<th>عنوان هشدار</th>
								<th class="border-l text-center hide-table-r hide-640">شاخص</th>
								<th class="border-l text-center">توضیحات</th>
								<th class="border-l text-center hide-table-r hide-640 w300">ساعت و تاریخ</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="history_item in history" :key="history_item.id">
								<td class="border-l bg-gray w60 text-center">  {{ history_item.alert_id }}</td>
								<td class="border-l bg-gray"> {{ history_item.title }} </td>
								<td class="border-l text-center hide-table-r hide-640">{{ $helpers.json_pars(history_item.asset)['label'] }}</td>
								<td class="border-l text-center">{{ history_item.body }}</td>
								<td class="border-l text-center hide-table-r hide-640 w300">{{ toRelative(history_item.created_at) }}</td>
							</tr>
						</tbody>
					</table> 

					<div v-if="!history.length" class="popup-dash-empty">
						<i class="uil uil-bell" aria-hidden="true"></i>
						<span>تاریخچه ای برای نمایش موجود نمی باشد</span>
					</div>
				</slot>
			</div>
		</slot>
	</div>
</div>

</template>

<script>
	// این کامپوننت دارای اجزای ماژول هشدار ها در داشبورد می باشد
	import moment from "moment-jalaali";
	export default {
		name: 'Alert',
		components: {},
		data: function () {
			return {
				sidebarShow: false,
				alerts : [],
				history : [],
				markets : [],
				widgetLoad: true,
			}
		},
		mounted() {
			this.getAlerts();
		},
		methods: {
			// این متد جهت نمایش مناسب زمان مورد استفاده قرار میگیرد
			toRelative(date) {
				if (moment().diff(moment(date), 'days') < 30)
					return moment(date).fromNow();
				else
					return moment(date).format("dddd jD jMMMM jYYYY / HH:mm");
			},
			// این متد جهت باز کردن مودال افزودن و یا ویرایش هشدار جدید می باشد و همچنین کال بک مودال را هندل می نماید
			open_alert_add_modal(id = null) {
				let callbackEvent = this.$router.currentRoute.name + '_AddAlert_' + new Date().getTime();

				let action = ( id ) ? 'edit' : 'add';
				let alert = null;

				if ( id ) {
					let index = this.$helpers.getIndex(this.alerts, id);
					alert = this.alerts[index];
				}
				let modal_data = {
					modal: 'general_modal', 
					callbackEvent,
					component: 'AlertAddEdit.vue',
					config: {
						title: ( action == 'edit' ) ? 'ویرایش هشدار' : 'افزودن هشدار',
						icon: ( action == 'edit' ) ? 'uil uil-edit-alt with-icon' : 'uil uil-plus-circle with-icon',
						smallModal: true,
						data: {
							action,
							alert,
						},
					}
				};

				this.$root.$emit('open_modal', modal_data);

				this.$root.$on(callbackEvent, (response) => {
					// آرایه ای از خطا های رایج
					let server_response = {
						field_empty : 'فیلد ها الزامی می باشند',
						notification_required : 'حداقل یک نوع دریافت الزامی می باشد',
					};

					// if ( response.action == 'addAlert' ) {
						//  آماده سازی دیتای درخواست ای پی آی
	
						let api_data = {
							id : id,
							data : JSON.stringify(response.data.alert) 
						};

						
						//ارسال درخواست ای پی آی
						this.$helpers.makeRequest('POST', '/alert/create-edit-alert' , api_data).then(api_response => {
							this.$helpers.api_alert(api_response);
											
							// در صورتی در خواست ای پی آی خطایی داشت پیام مناسب نمایش دهد
							if(api_response.data.response.status === 'error') {
				
								this.$swal.fire({
									icon:"error",
									title: server_response[api_response.data.message],
									showConfirmButton:!1,
									timer:2000
								});
								return 0;
							}

							// در صورتی که در خواست ای پی آی موفقیت آمیز بود
							if(api_response.data.response.status === 'success') {
		
								this.$swal.fire({
									icon:"success",
									title:( action == 'edit' ) ? 'هشدار با موفقیت ویرایش شد' : 'هشدار با موفقیت افزوده شد',
									showConfirmButton:!1,
									timer:2000
								});

								this.getAlerts()
								return 0;
							}
						});
					// } 
				});
			},
			// این متد لیست هشدار های کاربر را دریافت می نماید
			getAlerts() {
				
				let api_data = {};

				//ارسال درخواست ای پی آی
				this.$helpers.makeRequest('GET', '/alert/alerts', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					this.alerts = api_response.data.response.detail.alerts;
					this.markets = api_response.data.response.detail.markets;
					this.widgetLoad = false;
				});
			},
			// این متد برای درخواست تاریخچه ی هشدار های که کاربر دریافت نموده است می باشد
			getHistory(id) {
				this.history = [];
				this.widgetLoad = true;
				// ارسال درخواست ای پی آی
				this.$helpers.makeRequest('GET', '/alert/history/' + id).then(api_response => {
					this.$helpers.api_alert(api_response);

					this.history = api_response.data.response.detail.history;
					this.widgetLoad = false;
				});
			},
			// این متد برای حذف هشدار استفاده می شود
			removeAlert(id) {
				this.$helpers.confirm('هشدار حذف!', {
					message: 'آیا از حذف این مورد اطمینان دارید؟',
				}).then((confirmed) => {
					if ( confirmed ) {
						let index = this.$helpers.getIndex(this.alerts, id);

						this.alerts.splice(index, 1);
						this.$helpers.makeRequest('DELETE', '/alert/delete/' + id).then(api_response => {
							this.$helpers.api_alert(api_response);

							if ( api_response.data.response.status == 'success' ) {
								this.$swal.fire({
									icon:"success",
									title:"هشدار با موفقیت حذف شد",
									showConfirmButton:!1,
									timer:2000
								});
							}else{
								this.$swal.fire({
									icon:"error",
									title:"مشکلی در حذف هشدار رخ داده است",
									showConfirmButton:!1,
									timer:2000
								});
							}
						});	
					}
				});
			},
			// این متد برای دریافت قیمت شاخص مورد نظر می باشد
			getPrice(symbol) {
				var market = this.markets.find(item => item.name == symbol);
				return market.p;
			},
			showSidebar(id) {
				this.sidebarShow = true;
				this.getHistory(id);
			},
			hideSidebar() {
				this.sidebarShow = false;
			}

		},
			


	}
</script>